<form (ngSubmit)="onSubmit(searchSortForm)" [formGroup]="searchSortForm" id="searchform">
  <div class="form-row">
    <div class="search-form-container form-group">
      <input id="srchBox" aria-label="search input"
        class="search-input search-input-text search-helper-text form-control" type="text" formControlName="search"
        autocomplete="off" placeholder="{{ 'search_placeholder' | translate }}">
      <input type="submit" class="submit-button" aria-required="true">
      <a role="link" aria-label="clear search" href="javascript:void(0);"
        class="form-control-clear glyphicon glyphicon-remove form-control-feedback hidden"
        (click)="clearSearch(searchSortForm)"></a>

    </div>
  </div>
  <div class="form-row">
    <div class="bounding-box">
      <div class=sort-section>
        <label for="sortfilter" tabindex="0" class="sort-label">{{ 'sort_by' | translate }}:</label>
        <simple-dropdown *ngIf="productSort.length" [totalProducts]="totalProducts" [productSort]="productSort"
          (optionChange)="onSort($event)"></simple-dropdown>
      </div>

      <div class="grid-container {{screenWidth}}" *ngIf="screenWidth!='SM'">
        <label class="search-label">{{ 'view' | translate }}:</label>
        <input type="button" aria-label="list view" (click)="updateView($event, 'list')"
          [ngClass]="currentView === 'list' ? 'list-view-active' : 'list-view-default'" />
        <input type="button" aria-label="grid view" (click)="updateView($event, 'grid')"
          [ngClass]="currentView === 'grid' ? 'grid-view-active' : 'grid-view-default'" />
      </div>
    </div>
  </div>
</form>